<span class="loader"
    [ngClass]="{shape: type !== SkeletonShape.bar, circle: type === SkeletonShape.circle, square: type === SkeletonShape.square}"
    [ngStyle]="{width: width, height: height || width}">
</span>
